export const ANDROID = 'android';
export const IOS = 'ios';
